import React, { useState } from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, ComposedChart, Line, Bar } from 'recharts';

export default function BarMixedCharts({ heading, setFilters, chartFilterValues, AreaData, xDataKeyName, BarDataKeyName, LineDataKeyName, showFilters, colorType, LegendLeft, LegendRight, showSelectBox ,chartHeight=300 }) {

    const handleWise = (e, type) => {
        setFilters((prev) => ({
            ...prev,
            [type]: e
        }))
    }
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>

                    {
                        showFilters ?

                            <div style={{ display: 'flex', gap: '5px' }}>
                                <button className={`customArea-btn ${chartFilterValues?.type == "daily" ? "active" : ""}`} onClick={() => handleWise("daily", "type")}>Daily</button>
                                <button className={`customArea-btn ${chartFilterValues?.type == "weekly" ? "active" : ""}`} onClick={() => handleWise("weekly", "type")}>Weekly</button>
                                <button className={`customArea-btn ${chartFilterValues?.type == "monthly" ? "active" : ""}`} onClick={() => handleWise("monthly", "type")}>Monthly</button>
                                {
                                    showSelectBox ?
                                        <select className='customArea-btn' onChange={(e) => handleWise(e.target.value, "apiType")} value={chartFilterValues?.apiType}>
                                            <option value={""}>Select Api</option>
                                            {
                                                chartFilterValues?.apiList?.length > 0 ? chartFilterValues?.apiList?.map((val, id) => {
                                                    return (
                                                        <option value={val}>{val}</option>
                                                    )
                                                })
                                                    : ""}
                                        </select>
                                        : ""}
                            </div>
                            : ""}
                </div>
                <div style={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: '#fff', border: colorType == "purpleishRed" ? '1px solid rgba(159, 134, 189, 1)' : colorType == "purpleishBlue" ? " 1px solid rgba(66, 164, 199, 1)" : "", width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: window.innerWidth >=1800 ? '14px' : '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{LegendLeft}</h5>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <div style={{ background: '#fff', border: colorType == "purpleishRed" || colorType == "purpleishBlue" ? '1px solid rgba(255, 66, 66, 0.46)' : "", width: "8px", height: '8px', borderRadius: '50%' }}></div>
                        <h5 style={{ fontSize: window.innerWidth >=1800 ? '14px' : '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>{LegendRight}</h5>
                    </div>
                </div>
                <div>
                    {
                        AreaData?.length > 0 ?
                            <div style={{ height: chartHeight + "px"}}>
                                <ResponsiveContainer width="100%" height="100%">
                                    <ComposedChart
                                        // style={{ width: '100%', maxWidth: '700px', maxHeight: '70vh', aspectRatio: 1.618 }}
                                        responsive
                                        data={AreaData}
                                        margin={{
                                            top: 20,
                                            right: 0,
                                            left: 0,
                                            bottom: 0,
                                        }}
                                    >

                                        <CartesianGrid vertical={false} />
                                        <XAxis dataKey={xDataKeyName} axisLine={false} tick = {{fontSize: window.innerWidth >= 1800 ? '19px ' : '14px'}} />
                                        <YAxis  axisLine={false} tick = {{fontSize: window.innerWidth >= 1800 ? '19px ' : '14px'}}/>
                                        <Tooltip contentStyle={{ fontSize:  window.innerWidth >= 1800 ? '19px ' : '14px' }} />

                                        <Bar dataKey={BarDataKeyName} barSize={20}
                                            fill={colorType == "purpleishRed" ? "#9f86bdff" : colorType == "purpleishBlue" ? "rgba(66, 164, 199, 1)" : ""}
                                        />
                                        <Line type="monotone" dataKey={LineDataKeyName}
                                            stroke={colorType == "purpleishRed" || colorType == "purpleishBlue" ? "#ff4242ff" : ""}
                                            dot={{
                                                r: 3,
                                                fill: '#ffffff',
                                                stroke: colorType == "purpleishRed" || colorType == "purpleishBlue" ? "#ff4242ff" : "",
                                                strokeWidth: 1
                                            }}
                                        />
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </div>
                            : ""}
                </div>
            </div>
        </>
    )
}
